const actions = {
	
	FETCH_CREDIT_BEGIN: 'FETCH_CREDIT_BEGIN',
	FETCH_CREDIT_SUCCESS: 'FETCH_CREDIT_SUCCESS',
	FETCH_CREDIT_ERR: 'FETCH_CREDIT_ERR',

	FETCH_HISTORY_BEGIN: 'FETCH_HISTORY_BEGIN',
	FETCH_HISTORY_SUCCESS: 'FETCH_HISTORY_SUCCESS',
	FETCH_HISTORY_ERR: 'FETCH_HISTORY_ERR',

	fetchCreditBegin: () => {
		return {
			type: actions.FETCH_CREDIT_BEGIN,
		};
	},

	fetchCreditSuccess: (data) => {
		return {
			type: actions.FETCH_CREDIT_SUCCESS,
			data,
		};
	},

	fetchCreditErr: (err) => {
		return {
			type: actions.FETCH_CREDIT_ERR,
			err,
		};
	},

	fetchCreditHistoryBegin: () => {
		return {
			type: actions.FETCH_HISTORY_BEGIN,
		};
	},

	fetchCreditHistorySuccess: (data) => {
		return {
			type: actions.FETCH_HISTORY_SUCCESS,
			data,
		};
	},

	fetchCreditHistoryErr: (err) => {
		return {
			type: actions.FETCH_HISTORY_ERR,
			err,
		};
	},

};

export default actions;
